import React, { Fragment } from "react";
import IntlMessages from "../helpers/IntlMessages";

const Footer = ({ handleManage, ariIntegration, activePage }) => {
    return (<Fragment>
            <div id="footer-bar" className="footer-bar footer-bar-detached">
                <a href="#" onClick={() => handleManage('page', 'search')}
                    className={`icon-link${activePage === 'search' ? ' active' : ''}`}
                >
                    <svg className="mb-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.25" stroke="currentColor" width={20} height={20}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                    <span><IntlMessages id="footer.knowledge" /></span>
                </a>
                <a href="#" onClick={() => handleManage('page', 'main')}
                    className={`icon-link${activePage === 'main' ? ' active' : ''}`}
                >
                    <svg className="mb-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.25" stroke="currentColor" width={20} height={20}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                    </svg>
                    <span><IntlMessages id="footer.home" /></span>
                </a>

                <a href="#" onClick={() => handleManage('page', 'help')}
                    className={`icon-link${activePage === 'help' ? ' active' : ''}`}
                >
                    <svg className="mb-1" width={20} height={20} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" strokeWidth="2.25" stroke="currentColor">
                        <path d="M12 4C9.243 4 7 6.243 7 9h2c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.069-.454 1.465-1.481 2.255-.382.294-.813.626-1.226 1.038C10.981 13.604 10.995 14.897 11 15v2h2v-2.009c0-.024.023-.601.707-1.284.32-.32.682-.598 1.031-.867C15.798 12.024 17 11.1 17 9c0-2.757-2.243-5-5-5zm-1 14h2v2h-2z" />
                    </svg>
                    <span><IntlMessages id="footer.help" /></span>
                </a>

                {ariIntegration !== undefined && ariIntegration?.Id &&
                    <a href="#" onClick={() => handleManage('page', 'ari')}
                        className={`icon-link${activePage === 'ari' ? ' active' : ''}`}
                    >
                        <svg className="mb-1" width={20} height={20} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" strokeWidth="2.25" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                        </svg>
                        <span>ARI</span>
                    </a>
                }
            </div>
        </Fragment>
    );
}

export default Footer;